import * as React from "react"
import { Link } from "gatsby"
import { floatingButtonStyle } from './floatingButton.module.scss'
import chatImage from '../images/chat.png' // Adjust the path based on your directory structure


const FloatingButton = ({linkIt}) => (
    <Link to={linkIt} className={floatingButtonStyle}>
        <img src={chatImage} alt="Contact Us" style={{ maxWidth: '5rem' }} />
    </Link>
)

export default FloatingButton
